module.exports = __webpack_public_path__ + "assets/img/sample_user_profile.080b9277.png";